import React, {Component} from 'react'
import {observer} from 'mobx-react'

import ProfileDocumentSettings from './document/ProfileDocumentSettings'
import ProfileShopSettings from './shop/ProfileShopSettings'
import ProfileDeliverySettings from './delivery/ProfileDeliverySettings'
import ProfileRouteSettings from './route/ProfileRouteSettings'
import ProfileCategorySettings from './category/ProfileCategorySettings'
import ProfileCatalogSettings from './catalog/ProfileCatalogSettings'
import ProfileOfferFieldMappingSettings from './offer/field_mapping/ProfileOfferFieldMappingSettings'
import ProfilePromosSettings from './promo/ProfilePromosSettings'
import Cookies from "js-cookie";

@observer export default class ProfileSettingsComponent extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const v2 = Cookies.get('force_set_wa_backend_ui_version') == 2

        return (
            <div className={ v2 ? 'fields form' : ''}>
                <ProfileDocumentSettings context={context}/>
                <ProfileShopSettings context={context} title="1. Настройки магазина"/>
                <ProfileRouteSettings context={context} title="2. Настройки URL"/>
                <ProfileDeliverySettings context={context} title="3. Настройки доставки и самовывоза"/>
                <ProfileCategorySettings context={context} title="4. Экспорт категорий"/>
                <ProfileCatalogSettings context={context} title="5. Экспорт товаров"/>
                <ProfileOfferFieldMappingSettings context={context} title="6. Экспорт характеристик товаров"/>
                <ProfilePromosSettings context={context} title="7. Промоакции"/>
            </div>
        )
    }
}